import { connect } from 'react-redux';

import { getCoworkingGallery } from 'shared/store/coworking/selectors/smart/getCoworkingGallery';

import { IApplicationState } from '../../types/redux';

import { Carousel as CarouselComponent } from './Carousel';

export const mapState = (state: IApplicationState) => ({
  media: getCoworkingGallery(state),
});

export const Carousel = connect(mapState)(CarouselComponent);
